import React, { memo, MouseEvent, ReactElement, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { DataListPopup } from 'reactApp/sections/DataListPopup/DataListPopup';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './SelectFromCloudPopup.css';

export const SelectFromCloudPopup = memo(function SelectFromCloudPopup(props: any): ReactElement {
    const { onSuccess, onClose } = props;
    const selectedIds = useSelector(SelectionsSelectors.getSelectedIdxs);

    const handleClose = useCallback((): void => {
        onClose();
    }, [onClose]);

    const handleSuccess = useCallback(
        (e: MouseEvent): void => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
            onSuccess();
        },
        [onClose, onSuccess]
    );

    return (
        <DataListPopup onClose={handleClose} title="Выбрать фото из Облака" storage={EStorageType.gallery} viewMode={EViewMode.gallery}>
            {selectedIds.length ? (
                <Button theme="vk" primary className={styles.root} onClick={handleSuccess}>
                    Добавить в альбом
                </Button>
            ) : undefined}
        </DataListPopup>
    );
});
